
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import { getCookie } from '../../assets/js/common'

// 公共状态
// 是否登录
const initIslogin = getCookie('utoken') === null || getCookie('utoken') === '' ? false : getCookie('utoken')
// console.log(initIslogin === '')
export const islogin = (state = initIslogin, action) => {
  switch (action.type) {
    case 'SETLOGINTYPE':
      return action.value

    default:
      return state
  }
}

// 首页弹窗
export const showPop = (state = false, action) => {
  switch (action.type) {
    case 'SETPOPTYPE':
      return action.value

    default:
      return state
  }
}

// 放大图片
export const fullImg = (state={ url: '', show: false }, action) => {
  switch (action.type) {
    case 'SETFULLIMG':
      var data = state
      data = Object.assign({}, data, action.data)
      return data

    default:
      return state
  }
}

// 全局loading
export const loadingPop = (state = false, action) => {
  switch (action.type) {
    case 'SETLOADINGPOP':
      // console.log(action.value)
      return action.value

    default:
      return state
  }
}

// 声音弹窗
export const voiceModalVisible = (state = false, action) => {
  switch (action.type) {
    case 'UPDATEVOICEMODALVISIBLE':
      return action.value

    default:
      return state
  }
}

// 声音开关
const initOnOffvoice = {
  backgroundVoice: getCookie('backgroundVoice') || 'opened',
  actionVoice: getCookie('actionVoice') || 'opened',
}
export const onOffVoice = (state = initOnOffvoice, action) => {
  switch (action.type) {
    case 'UPDATEVOICE':
      return Object.assign({}, state, {[action.key]: action.value})

    default:
      return state
  }
}